import { FC } from 'react'
import cn from 'classnames'

interface INotFoundPage {
  icon: React.ReactNode
  text: React.ReactNode
  title: React.ReactNode
  actions?: React.ReactNode
}
export const TechPageTemplate: FC<INotFoundPage> = (props) => {
  const { actions = '', icon, title, text } = props

  return (
    <div className="flex grow items-center justify-center p-2 md:p-0">
      <div className="flex max-w-[600px] flex-col items-center rounded-xl bg-surface p-4 md:p-16">
        {icon}
        <div className="mb-2 text-center text-title-lg md:mb-4">{title}</div>
        <div className={cn('text-balance text-center text-body-lg', { 'mb-3 md:mb-6': Boolean(actions) })}>{text}</div>
        {actions}
      </div>
    </div>
  )
}
